// extracted by mini-css-extract-plugin
module.exports = {"hsContainer":"styles_hsContainer__2qvHF","hsWrapper":"styles_hsWrapper__3pixT","full":"styles_full__Ttp84","hs":"styles_hs__2RvFs","noScrollbar":"styles_noScrollbar__2LWbV"};